// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getValidationErrorMessage = (e?: any): string | undefined => {
  const message = e?.response?.data?.validation?.errors?.[0]?.message;

  if (typeof message === "string") {
    return message;
  }

  return undefined;
};
